import styled from 'styled-components';
import { Grid } from '@elliemae/ds-basic/Grid';

var m = '0.61538rem';
var m2 = '1.23076rem';
var CellWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1n8exyf-0"
})(["max-height:36px;height:100%;width:", ";margin-left:", ";margin-right:", ";padding-left:", ";padding-right:", ";", ";", ""], function (props) {
  return props.noPadding ? "calc(100% + ".concat(m2, ")") : '100%';
}, function (props) {
  return props.noPadding ? "-".concat(m) : '0';
}, function (props) {
  return props.noPadding ? "-".concat(m) : '0';
}, function (props) {
  return !props.hasLeftAddon && (props.badgeAddon || props.highLight || props.hasRightAddon) ? m : '0';
}, function (props) {
  return !props.hasRightAddon && (props.badgeAddon || props.highLight || props.hasLeftAddon) ? m : '0';
}, function (props) {
  return props.highLight ? "background: ".concat(props.theme.colors.brand['200']) : '';
}, function (props) {
  return props.badgeAddon ? "\n  position: relative;  \n  &::before {\n    display: block;\n    content: '';\n    position: absolute;\n    top: 0;\n    left:0;\n    border-style: solid;\n    border-width:  ".concat(props.theme.space.xxs, " ").concat(props.theme.space.xxs, "  ").concat(props.theme.space.xxs, " 0;\n    border-color: ").concat(props.theme.colors.brand['600'], " transparent  transparent ").concat(props.theme.colors.brand['600'], ";\n  }\n  ") : '';
});
var ValueWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1n8exyf-1"
})(["display:flex;align-items:center;overflow:hidden;& > span{display:inline-flex;align-items:center;}", ""], function (props) {
  return props.grayText ? "color: ".concat(props.theme.colors.neutral['500'], ";") : '';
});
var CellContainer = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "sc-1n8exyf-2"
})(["padding-left:", ";padding-right:", ";position:relative;"], m, m);

export { CellContainer, CellWrapper, ValueWrapper };
//# sourceMappingURL=styled.js.map
